import enhancedFetch from "Utils/enhancedFetch";
import { API_URL } from "Utils/envVariables";
import { FETCH_DEFAULT_CONFIGS_TOKEN } from "../config";
import {
  ConciliationResponse,
  conciliationResponseDecoder,
  CreditorAccountResponse,
  creditorAccountResponseDecoder,
} from "./interfaces";

export async function getCoopBarcelonaAccounts(): Promise<CreditorAccountResponse> {
  const response = await enhancedFetch(`${API_URL}/dms/coop_barcelona_accounts/`, {
    ...FETCH_DEFAULT_CONFIGS_TOKEN(true),
    method: "GET",
  });

  return creditorAccountResponseDecoder.verify(await response.json());
}

export async function conciliation(payload: FormData): Promise<ConciliationResponse> {
  const response = await enhancedFetch(`${API_URL}/dms/conciliation/`, {
    ...FETCH_DEFAULT_CONFIGS_TOKEN(false),
    method: "POST",
    body: payload,
  });

  return conciliationResponseDecoder.verify(await response.json());
}
